import { defineComponent as _defineComponent } from 'vue'
import { Portal } from '@/modules/common/components/Portal';
import { CloseButton } from '@/modules/common/components/buttons';
import {
  NavBar,
  BaseText,
  Heading,
  HeadingDisplay,
  InitialAvatarIcon,
  BaseModal,
  Row
} from '@warrenbrasil/nebraska-web';

interface Props {
  open: boolean;
}

interface Emits {
  (event: 'close'): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeCashDepositModalV2',
  props: {
    open: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'close'): void;
}), expose: any, slots: any, attrs: any }) {

const depositOptions = [
  {
    title: 'Pix',
    subtitle: 'Transferência imediata',
    icon: 'BA0110',
    path: 'deposit-pix'
  },
  {
    title: 'TED',
    subtitle: 'Transferência em algumas horas',
    icon: 'EA0120',
    path: 'deposit-ted'
  }
];





const handleClose = () => {
  emits('close');
};

return { __sfc: true,depositOptions, emits, handleClose, Portal, CloseButton, NavBar, BaseText, Heading, HeadingDisplay, InitialAvatarIcon, BaseModal, Row }
}

})